import { withKeycloak } from "@react-keycloak/web";
import debounce from "lodash.debounce";
import React from "react";
import { withRouter } from "react-router-dom";
import { labels } from "../../../../localization/labels";
import { messages } from "../../../../localization/messages";
import EntityRatingService from "../../../../services/EntityRatingService";
import EntityRelationshipService from "../../../../services/EntityRelationshipService";
import { selectFilter } from "../../../../services/FilteringUtils";
import KnowledgeCopyrightService from "../../../../services/KnowledgeCopyrightService";
import KnowledgeService from "../../../../services/KnowledgeService";
import KnowledgeTypeService from "../../../../services/KnowledgeTypeService";
import LifeCycleService from "../../../../services/LifeCycleService";
import PartyService from "../../../../services/PartyService";
import TagService from "../../../../services/TagService";
import CommonUtil from "../../../../utils/CommonUtil";
import { constants } from "../../../../utils/Constants";
import PathUtil from "../../../../utils/PathUtil";
import SecurityUtils from "../../../../utils/SecurityUtils";
import { paths } from "../../../paths";
import { calcKnowledgeItemSearchSimilar } from "../../page/SearchSimilar/SearchSimilar";
import SubControlComponent from "../../page/SubControlComponent";
import {
  knowledgeItemValidationRules as validationRules,
  validateEntity
} from "./../../../../validators/validationRules";
import Knowledgeitem from "./KnowledgeItem";

class KnowledgeItemContainer extends SubControlComponent {
  constructor(props) {
    super(props);

    this.knowledgeService = new KnowledgeService(this.keycloak);
    this.tagService = new TagService(this.keycloak);
    this.knowledgeTypeService = new KnowledgeTypeService(this.keycloak);
    this.lifeCycleService = new LifeCycleService(this.keycloak);
    this.partyService = new PartyService(this.keycloak);
    this.entityRatingsService = new EntityRatingService(this.keycloak);
    this.knowledgeCopyrightService = new KnowledgeCopyrightService(
      this.keycloak
    );
    this.entityRelationshipService = new EntityRelationshipService(
      this.keycloak
    );

    this.state = {
      id: this.resolveItemId(),
      isChanged: false,
      numberOfDocuments: 0
    };
    this.state = this.initialState(this.state);
    this.sortInfo = {
      orderBy: "id",
      direction: "asc"
    };

    //delay of 500 ms(0.5s) on method for text input
    this.onChangeDebounced = debounce(this.onChangeDebounced, 500);
  }

  componentDidUpdate(prevProps) {
    const newId = this.resolveItemId();

    if (newId !== PathUtil.pathParameter(prevProps, "id")) {
      this.state.id = newId;

      this.setState(this.initialState(this.state));
      this.loadData();
    }

    let blocked = this.state.shouldBlockNavigation;
    if (this.state.isChanged) {
      blocked = CommonUtil.checkValuesChanged(
        this.state.oldEntity,
        this.state.entity,
        [
          "entityRelationships.relatedEntity.id",
          "entityRelationships.entityRelationshipType.id"
        ]
      );
      this.setState({ isChanged: false, shouldBlockNavigation: blocked });
    }

    if (blocked) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  subArrayUniqueDataElementFilter = (subArrayPath, arrayElement, element) => {
    var exists = false;

    if (subArrayPath === this.getSubArraysPaths()[0]) {
      exists =
        arrayElement.entity.id === element.entity.id &&
        arrayElement.relatedEntity.id === element.relatedEntity.id &&
        arrayElement.entityRelationshipType.id ===
          element.entityRelationshipType.id;
    }

    return exists;
  };

  initialState = state => {
    return {
      ...state,
      entity: { entityRelationships: undefined },
      oldEntity: undefined,
      knowledgeTypes: [],
      knowledgeLifeCycles: [],
      knowledgeRatings: {},
      disabled: true,
      isNew: true,
      rating: {},
      shouldBlockNavigation: false,
      editable: true,
      lifeCycleEditable: false,
      reloadLifeCycleHistoryLog: false,
      searchSimilar: false
    };
  };

  loadData = () => {
    if (this.state.id) {
      this.loadKnowledgeItem(this.state.id);
    } else {
      this.setComponentTitle(labels.knowledgeItem);
      this.setState({
        classificationsFilter: SecurityUtils.geClassificationsByOperation(
          constants.OPERATION_CREATE
        )
      });
    }
  };

  getComponentTitle = () => {
    return this.state.entity ? this.state.entity.name : undefined;
  };

  loadKnowledgeItem = id => {
    this.prepareCall(
      this.knowledgeService.getEntityById(
        id,
        this.onKnowledgeItemLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onKnowledgeItemLoad = data => {
    this.resetFlags = this.setResetFlags(true);

    const editable = SecurityUtils.partyHasPermissionOnEntity(
      data,
      constants.OPERATION_PATCH
    );
    const lifeCycleEditable = SecurityUtils.partyHasPermissionOnEntity(
      data,
      constants.OPERATION_CHANGE_LIFECYCLE
    );
    const operation = editable
      ? constants.OPERATION_PATCH
      : constants.OPERATION_READ;
    this.setState({
      classificationsFilter: SecurityUtils.geClassificationsByOperation(
        operation
      )
    });
    this.setState({
      entity: { ...data },
      oldEntity: { ...data },
      disabled: false,
      isNew: false,
      editable: editable,
      lifeCycleEditable: lifeCycleEditable,
      numberOfDocuments: data.numberOfDocuments,
      hasActivateDeactivateAction: SecurityUtils.partyHasPermissionOnEntity(
        { ...data },
        constants.OPERATION_DELETE
      )
    });

    this.setComponentTitle(this.state.entity.name, true);
    this.loadInitialKnowledgeCopyright(data);
    this.loadKnowledgeType(data);
    this.loadKnowledgeLifeCycle(data);
    this.loadRecordedBy(data);
    this.loadRatings();
    this.loadEntityRating(data);
    this.loadKnowledgeItemTags(data);
    this.loadKnowledgeItemAutoTags(data);
  };

  loadKnowledgeItemTags = data => {
    const url = data._links.tags.href;
    this.prepareCall(
      this.tagService.getEntitiesByUrl(
        url,
        this.onKnowledgeTagLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onKnowledgeTagLoad = data => {
    let tags = CommonUtil.getDataContent(data) || [];
    this.setEntityProperty("tags", tags, true);
  };

  loadKnowledgeItemAutoTags = data => {
    const url = data._links.autoTags.href;
    this.prepareCall(
      this.tagService.getEntitiesByUrl(
        url,
        this.onKnowledgeAutoTagLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onKnowledgeAutoTagLoad = data => {
    this.setEntityProperty("autoTags", data, true);
  };

  loadInitialKnowledgeCopyright = data => {
    const url = data._links.knowledgeCopyrights.href;
    this.prepareCall(
      this.knowledgeCopyrightService.getEntitiesByUrl(
        url,
        this.onInitialKnowledgeCopyrightLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onInitialKnowledgeCopyrightLoad = data => {
    let knowledgeCopyright;
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      knowledgeCopyright = dataContent[0];
    }
    this.setEntityProperty("knowledgeCopyright", knowledgeCopyright, true);
  };

  loadRecordedBy = data => {
    const url = data._links.recordedBy.href;
    this.loadParty(url, this.onRecordedByLoad);
  };

  loadParty = (url, callback) => {
    this.prepareCall(
      this.partyService.getEntitiesByUrl(
        url,
        callback,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  loadKnowledgeType = data => {
    const url = data._links.knowledgeTypes.href;
    this.prepareCall(
      this.knowledgeTypeService.getEntitiesByUrl(
        url,
        this.onKnowledgeTypeLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  loadKnowledgeLifeCycle = data => {
    const url = data._links.lifeCycles.href;
    this.prepareCall(
      this.lifeCycleService.getEntitiesWithParams(
        url,
        undefined,
        undefined,
        this.onKnowledgeLifeCycleLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  loadKnowledgeLifeCycles = knowledgeLifeCycle => {
    const url = knowledgeLifeCycle._links.nextLifeCycles.href;
    this.prepareCall(
      this.lifeCycleService.getEntitiesWithParams(
        url,
        undefined,
        undefined,
        this.onKnowledgeLifeCyclesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  loadRatings = () => {
    const url = this.state.entity._links.calculateRatings.href;
    this.prepareCall(
      this.knowledgeService.post(
        url,
        undefined,
        this.onRatingsLoaded,
        undefined,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  loadEntityRating = data => {
    const entityRatingFilterInfo = {
      filters: {
        entityId: selectFilter(data.id)
      }
    };

    this.prepareCall(
      this.entityRatingsService.getEntityRatings(
        entityRatingFilterInfo,
        undefined,
        this.onEntityRatingLoaded,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onEntityRatingLoaded = data => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent[0]) {
      this.setState({
        rating: dataContent[0].rating
      });
    }
  };

  onRatingsLoaded = data => {
    const ratings = data ? data : {};
    this.setState({ knowledgeRatings: ratings });
  };

  onKnowledgeLifeCyclesLoad = data => {
    var nextKnowledgeLifeCycles = [];
    if (data._embedded !== undefined) {
      nextKnowledgeLifeCycles = data._embedded.content;
    }
    const { entity } = this.state;
    const currentKnowledgeLifeCycle = entity.lifeCycle;
    nextKnowledgeLifeCycles.push(currentKnowledgeLifeCycle);
    this.setState({ knowledgeLifeCycles: nextKnowledgeLifeCycles });
  };

  onKnowledgeTypeLoad = data => {
    const knowledgeType = data._embedded.content[0];
    const { entity, oldEntity } = this.state;
    entity.knowledgeType = knowledgeType;
    oldEntity.knowledgeType = knowledgeType;
    this.setState({
      entity: entity,
      oldEntity: oldEntity
    });
  };

  onKnowledgeLifeCycleLoad = data => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      const knowledgeLifeCycle = dataContent[0];
      const { entity, oldEntity } = this.state;
      entity.lifeCycle = knowledgeLifeCycle;
      oldEntity.lifeCycle = knowledgeLifeCycle;
      this.setState({
        entity: entity,
        oldEntity: oldEntity,
        reloadLifeCycleHistoryLog: true
      });
      this.loadKnowledgeLifeCycles(knowledgeLifeCycle);
    }
  };

  onRecordedByLoad = data => {
    const { entity, oldEntity } = this.state;
    entity.recordedBy = data;
    oldEntity.recordedBy = data;
    this.setState({
      entity: entity,
      oldEntity: oldEntity
    });
  };

  onChangeDebounced = knowledgeItem => {
    this.onChangeValidation(knowledgeItem);
    this.setSearchSimilar(knowledgeItem);
  };

  onChangeValidation = knowledgeItem => {
    const disabled = !this.validator(knowledgeItem);
    this.setState({ isChanged: true, disabled: disabled });
  };

  validator = entity => {
    return validateEntity(entity, validationRules.knowledgeItem);
  };

  onChange = event => {
    let entity = this.state.entity;
    entity[event.target.id] = event.target.value;
    this.setState({
      entity: entity
    });

    if (typeof event.target.value === "object") {
      this.onChangeValidation(entity);
    } else {
      this.onChangeDebounced(entity);
    }
  };

  setSearchSimilar = entity => {
    const searchSimilarObject = calcKnowledgeItemSearchSimilar(entity);
    this.setState(searchSimilarObject);
  };

  onRatingChange = rating => {
    this.setState({
      rating: rating
    });
    const entityRating = {
      entity: {
        id: this.state.entity.id,
        type: this.state.entity.type
      },
      rating: rating
    };

    this.prepareCall(
      this.entityRatingsService.postEntityRating(
        entityRating,
        this.loadRatings,
        this.onSaveSuccessMessage,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  saveNewEntity = entity => {
    this.prepareCall(
      this.knowledgeService.postEntity(
        entity,
        this.onDataResponse,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage
      )
    );
    this.performCalls();
  };

  updateEntity = entity => {
    this.prepareCall(
      this.knowledgeService.patchEntity(
        entity,
        this.state.oldEntity,
        this.onDataResponse,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage,
        undefined,
        [
          "/classifications/\\d+/leaf",
          ".*/_links",
          "/entityRelationships/\\d+/noName",
          "/entityRelationships/\\d+/noDescription",
          "/entityRelationships/\\d+/noDateRange",
          "/entityRelationships/\\d+/entity/active",
          "/entityRelationships/\\d+/relatedEntity/active",
          "/entityRelationships/\\d+/entityRelationshipType/active"
        ],
        [
          "/entityRelationships/\\d+/entity/id",
          "/entityRelationships/\\d+/entity/type",
          "/entityRelationships/\\d+/relatedEntity/id",
          "/entityRelationships/\\d+/relatedEntity/type",
          "/entityRelationships/\\d+/entityRelationshipType/id",
          "/tags/\\d+/name"
        ],
        ["/entityRelationships", "/tags", "/classifications"]
      )
    );
    this.performCalls();
  };

  onDataResponse = data => {
    this.setState({ shouldBlockNavigation: false });
    if (this.state.id) {
      this.loadKnowledgeItem(this.state.id);
    } else {
      this.changePath(
        PathUtil.itemPath(paths.KNOWLEDGE_ITEM, data.id),
        data.name
      );
    }
  };

  getSubArraysPaths = () => {
    return ["entityRelationships"];
  };

  resetReloadingLifeCycleHistoryLog = () => {
    this.setState({ reloadLifeCycleHistoryLog: false });
  };

  onDeleteData = () => {
    this.prepareCall(
      this.knowledgeService.deleteEntity(
        this.state.entity,
        this.onDataDeactivateReactivateResponse,
        this.onDeleteSuccessMessage,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onReactivateData = () => {
    const entity = CommonUtil.jsonCopy(this.state.oldEntity);
    entity.isDeleted = false;
    this.prepareCall(
      this.knowledgeService.patchEntity(
        entity,
        this.state.oldEntity,
        this.onDataDeactivateReactivateResponse,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage
      )
    );
    this.performCalls();
  };

  onDataDeactivateReactivateResponse = data => {
    this.changePath(paths.KNOWLEDGE_MANAGMENT, labels.KNOWLEDGE_MANAGMENT);
  };

  handleDeactivateReactiveAction = (event, deactivate) => {
    event.preventDefault();
    let message = this.state.shouldBlockNavigation
      ? messages.changesNotSavedWarn + " "
      : "";
    message += deactivate
      ? messages.deactivate_confirm_message
      : messages.reactivate_confirm_message;
    const confirmed = window.confirm(message);
    if (confirmed) {
      this.setState({ shouldBlockNavigation: false });
      if (deactivate) {
        this.onDeleteData();
      } else {
        this.onReactivateData();
      }
    }
  };

  setNumberOfDocuments = numberOfDocuments => {
    this.setState({ numberOfDocuments: numberOfDocuments });
  };

  setAddRelatedEntityRelationship = addRelatedEntityRelationship => {
    this.addRelatedEntityRelationship = relatedEntity =>
      addRelatedEntityRelationship(relatedEntity);
  };

  render() {
    return (
      <Knowledgeitem
        {...this.renderProps()}
        onChange={this.onChange}
        knowledgeLifeCycles={this.state.knowledgeLifeCycles}
        validationRules={validationRules.knowledgeItem}
        disabled={this.state.disabled}
        isNew={this.state.isNew}
        {...this.handlerProps()}
        reloadLifeCycleHistoryLog={this.state.reloadLifeCycleHistoryLog}
        resetReloadingLifeCycleHistoryLog={
          this.resetReloadingLifeCycleHistoryLog
        }
        knowledgeRatings={this.state.knowledgeRatings}
        rating={this.state.rating}
        onRatingChange={this.onRatingChange}
        onRate={this.onRate}
        shouldBlockNavigation={this.state.shouldBlockNavigation}
        setInitialEntityPropertyState={(propertyName, propertyValue) =>
          this.setEntityProperty(propertyName, propertyValue, true)
        }
        loadParty={this.loadParty}
        setClassificationsOnEntity={classifications =>
          this.setEntityProperty("classifications", classifications)
        }
        editable={this.state.editable}
        lifeCycleEditable={this.state.lifeCycleEditable}
        classificationsFilter={this.state.classificationsFilter}
        removeFromRelationshipsTable={element =>
          this.removeFromSubArray(this.getSubArraysPaths()[0], element)
        }
        addToRelationshipsTable={element =>
          this.addToSubArray(this.getSubArraysPaths()[0], element)
        }
        updateInRelationshipsTable={element =>
          this.replaceInSubArray(this.getSubArraysPaths()[0], element)
        }
        resetRelationships={this.resetFlags[this.getSubArraysPaths()[0]]}
        setInitialRelationships={propertyValue =>
          this.setEntityProperty(
            this.getSubArraysPaths()[0],
            propertyValue,
            true
          )
        }
        onReactivate={
          !this.state.entity.active && this.state.hasActivateDeactivateAction
            ? e => this.handleDeactivateReactiveAction(e, false)
            : undefined
        }
        onDelete={
          this.state.entity.active && this.state.hasActivateDeactivateAction
            ? e => this.handleDeactivateReactiveAction(e, true)
            : undefined
        }
        searchSimilar={this.state.searchSimilar}
        entitySimilarSearch={this.state.entitySimilarSearch}
        numberOfDocuments={this.state.numberOfDocuments}
        setNumberOfDocuments={this.setNumberOfDocuments}
        addRelatedEntityRelationship={this.addRelatedEntityRelationship}
        setAddRelatedEntityRelationship={this.setAddRelatedEntityRelationship}
      />
    );
  }
}

export default withKeycloak(withRouter(KnowledgeItemContainer));
